import { MasterL10nMessages } from '@sm/question-ui/respondent-survey';
import { defineMessages } from '@sm/intl';

/**
 * Copy used by SMQuestions - re-declaring the messages here allows translation into the
 * 56 languages needed by RespWeb (as opposed to the 16 in SMQuestions)
 */
export const COPY: Omit<
  // Temp fix to update SMQuestions - Jordan is working on these translations
  // in https://code.corp.surveymonkey.com/webplatform/smweb/pull/12814
  // please remove this `Omit` code once they have been added
  MasterL10nMessages,
  | 'ERROR_PROVIDE_DATE_INTL_FORMAT'
  | 'ERROR_PROVIDE_DATE_US_FORMAT'
  | 'ERROR_ENTER_HOURS'
  | 'ERROR_ENTER_MINUTES'
  | 'ERROR_SELECT_PERIOD'
  | 'NPS_QUESTION_TITLE' // Mat please remove this in https://code.corp.surveymonkey.com/webplatform/smweb/pull/12860
> = defineMessages({
  QUESTION_TITLE: {
    id: 'QuestionFieldLayoutTemplate.QUESTION_TITLE',
    defaultMessage: 'Question Title',
    description: '[Type: Label][Vis: low] - question landmark for screen readers only',
  },
  NPS_QUESTION_TITLE: {
    id: 'Nps.QUESTION_TITLE',
    defaultMessage:
      '<div class="{srOnlyClass}">On a scale of {minValue} to {maxValue}, </div>{heading}<div id="{instructionsId}" class="{srOnlyClass}"> {minValue} for {minLabelText}, {maxValue} for {maxLabelText}</div>',
    description: '[Type: header][Vis: high] - question title',
  },
  OK_LABEL: {
    id: 'Button.OK_LABEL',
    defaultMessage: 'OK',
    description: '[Type: button][Vis: high] - question ok label',
  },
  PREVIOUS_MONTH: {
    id: 'CalendarPicker.previousMonth',
    defaultMessage: 'Previous Month',
    description: '[Type: button][Vis: high] - button label to go to previous month',
  },
  NEXT_MONTH: {
    id: 'CalendarPicker.nextMonth',
    defaultMessage: 'Next Month',
    description: '[Type: button][Vis: high] - button label to go to next month',
  },
  MONTH_SELECT: {
    id: 'CalendarPicker.month',
    defaultMessage: 'Select a month',
    description: '[Type: label][Vis: high] - label for month selection combo box',
  },
  YEAR_SELECT: {
    id: 'CalendarPicker.year',
    defaultMessage: 'Select a year',
    description: '[Type: label][Vis: high] - label for year selection combo box',
  },
  MONTHS: {
    id: 'CalendarPicker.months',
    defaultMessage:
      '{months, select, January {January} February {February} March {March} April {April} May {May} June {June} July {July} August {August} September {September} October {October} November {November} December {December}}',
    description: '[Type: label][Vis: high] - label for the months',
  },
  DAY_OF_WEEK_LEGEND_SHORT: {
    id: 'Month.dayOfWeekLegendShort',
    defaultMessage: '{dayOfTheWeek, select, Mo {Mo} Tu {Tu} We {We} Th {Th} Fr {Fr} Sa {Sa} Su {Su}}',
    description: '[Type: label][Vis: high] - label for the day of the week in shorthand',
  },
  DAY_OF_WEEK_LEGEND_FULL: {
    id: 'Month.dayOfWeekLegendLong',
    defaultMessage:
      '{dayOfTheWeek, select, Mo {Monday} Tu {Tuesday} We {Wednesday} Th {Thursday} Fr {Friday} Sa {Saturday} Su {Sunday}}',
    description: '[Type: label][Vis: high] - label for the day of the week',
  },
  DAY_OF_MONTH: {
    id: 'Day.dayOfMonth',
    defaultMessage: '{dayInCalendar, date, full}',
    description: '[Type: label][Vis: high] - label for the full date',
  },
});

export default COPY;
